import type { ReactNode } from 'react';
import { motion } from 'motion/react';

interface DeslizarEntradaProps {
  children: ReactNode;
  className?: string;
  /** Deslocamento inicial em px (padrão 24). */
  deslocamento?: number;
}

// Tela cheia que "entra" deslizando da direita (x 24 px + fade, 200 ms).
// Serve para abrir um cartão de hub e para o "← Voltar" (a tela do hub
// entra da mesma forma, então a sensação é de voltar).
export default function DeslizarEntrada({
  children,
  className = '',
  deslocamento = 24,
}: DeslizarEntradaProps) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, x: deslocamento }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}